import vuerouter from "vue-router";
import Home from "./Vistas/Home.vue";
import Login from "./Vistas/Login.vue";
import RecuperarContrasena from "./Vistas/RecuperarContrasena.vue";
import rutasRequisicionPago from "./Areas/Requisicion Pago/router";

const rutas: vuerouter.RouteRecordRaw[] = [
  { component: Login, path: "/", name: "srp-login" },
  { component: RecuperarContrasena, path: "/recuperar-contrasena", name: "srp-recuperar-contrasena" },
  { component: RecuperarContrasena, path: "/definir-contrasena", name: "srp-definir-contrasena" },
  { component: Home, path: "/home", children: rutasRequisicionPago }
];
export default rutas;
